import { ReactElement } from 'react';
import { UnitsInfoContainer } from './styles';
import Skeleton from 'react-loading-skeleton';

export function LoadingUnitsInfo(): ReactElement {
  return (
    <UnitsInfoContainer loading>
      <Skeleton borderRadius="8px" />
      <Skeleton borderRadius="8px" />
      <Skeleton borderRadius="8px" />
      <Skeleton borderRadius="8px" />
    </UnitsInfoContainer>
  );
}
